import { Provider } from "react-redux";
import { store } from "./app/store";
import Application from "./Application.jsx";
import { PersistGate } from "redux-persist/lib/integration/react";
import persistStore from "redux-persist/es/persistStore";
import Loader from "./components/common/LoaderCompoent/Loader.jsx";
import { AppErrorBoundary } from "./components/common/ErrorBoundary";
import "/node_modules/react-grid-layout/css/styles.css";
import "/node_modules/react-resizable/css/styles.css";
import { useEffect } from "react";
import { syncSocketConnection } from "./services/socketAuth";
import { socket } from "./socket/client";
export { socket } from "./socket/client";
const persistor = persistStore(store);
const App = () => {
  useEffect(() => {
    const onConnectLog = () => {
      console.log('Socket handshake successfully!');
    };
    const onDisconnect = () => {
      console.log("Socket disconnected App.");
      if (store.getState()?.persist?.isUserLogin) {
        setTimeout(() => socket.connect(), 500);
      }
    };
    const onConnectError = err => {
      console.log(`Socket connect_error due to ${err}`);
    };
    socket.on('connect', onConnectLog);
    socket.on("disconnect", onDisconnect);
    socket.on("connect_error", onConnectError);
    return () => {
      socket.off('connect', onConnectLog);
      socket.off("disconnect", onDisconnect);
      socket.off("connect_error", onConnectError);
    };
  }, []);
  useEffect(() => {
    const syncFromStore = () => syncSocketConnection(socket);
    syncFromStore();
    const unsubscribe = store.subscribe(syncFromStore);
    return unsubscribe;
  }, []);
  return <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AppErrorBoundary>
          <Loader />
          <Application />
        </AppErrorBoundary>
      </PersistGate>
    </Provider>;
};
export default App;